import { ActionTree } from "vuex";
import { AppHookCodes } from "@/data/enums/hooks";
import { IState } from "@/store";
import { IUser } from "@/models/users";

const initialState = () => ({});

const actions: ActionTree<{}, IState> = {
  [AppHookCodes.ADMIN_USER_LOGGED_IN]: async ({ dispatch }, user: IUser) => {
    await dispatch("ui/userflow/tryInit", user, { root: true });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions
};
